var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"corporation-card-testimonial"},[_c('div',{staticClass:"corporation-card-testimonial__img"},[_c('img',{attrs:{"src":`/images${_vm.img}`,"alt":"startup.png"}})]),_vm._v(" "),_c('div',{staticClass:"corporation-card-testimonial__desc"},[_c('p',[_vm._v(" "+_vm._s(_vm.desc))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }